var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VRow',{staticClass:"ma-0 mb-4"},[_c('h2',[_vm._v("The full content is only available to subscribers.")])]),_c('CtaGainAccess',{staticClass:"px-0 ml-1"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }